import { defineEntity, lifecycle, custom } from './_helpers.js';

export default defineEntity('document', {
    reviewDue:        lifecycle(),
    pendingApproval:  custom({ scope: 'state' }),
    approved:         custom({ scope: 'state' }),
    rejected:         custom({ scope: 'state' }),
});
